import {
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
} from '@ds-mgnl/marketing';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Platform',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'Overview',
								path: '/building-management-platform',
								value: '/building-management-platform',
								openInNewTab: false,
							},
							{
								label: 'Maintenance',
								path: '/building-management-platform/maintenance',
								value: '/building-management-platform/maintenance',
								openInNewTab: false,
							},
							{
								label: 'Housekeeping',
								path: '/building-management-platform/housekeeping',
								value: '/building-management-platform/housekeeping',
								openInNewTab: false,
							},
							{
								label: 'Capital Management',
								path: '/building-management-platform/capital-management',
								value: '/building-management-platform/capital-management',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Services',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'Overview',
								path: '/services',
								value: '/services',
								openInNewTab: false,
							},
							{
								label: 'Routine and Emergency Repairs',
								path: '/services/routine-and-emergency-repairs',
								value: '/services/routine-and-emergency-repairs',
								openInNewTab: false,
							},
							{
								label: 'Planned Projects',
								path: '/services/planned-projects',
								value: '/services/planned-projects',
								openInNewTab: false,
							},
							{
								label: 'Recurring Maintenance Programs',
								path: '/services/recurring-maintenance-programs',
								value: '/services/recurring-maintenance-programs',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Resources ',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'Expertise ',
								path: '/resources/blogs',
								value: '/resources/blogs',
								openInNewTab: false,
							},
							{
								label: 'Case Studies',
								path: '/resources/case-studies',
								value: '/resources/case-studies',
								openInNewTab: false,
							},
							{
								label: 'All resources',
								path: '/resources',
								value: '/resources',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
];

export const topNavServiceProviderData: NavBarItem[] = [
	{
		type: 'link',
		link: {
			label: 'Service providers',
			path: '/service-provider/',
			value: '/service-provider/',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'link',
		link: {
			label: 'Training',
			path: '/service-provider/training/',
			value: '/service-provider/training/',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'submenu',
		label: 'Resources ',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								label: 'TELS Connect Walkthrough',
								path: '/collateral-library/tels-connect-tech-overview-17877',
								value: '/collateral-library/tels-connect-tech-overview-17877',
								openInNewTab: false,
							},
							{
								label: 'Expectations',
								path: '/collateral-library/tels-building-services-interior-service-provider-expectations',
								value:
									'/collateral-library/tels-building-services-interior-service-provider-expectations',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			label: '888-225-7729',
			path: 'tel:888-225-7729',
			value: 'tel:888-225-7729',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
];
